import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";
import { $toast } from "vuetify-snackbar-toast";

// Módulo Censo Escolar: acesso restrito a super-admin e admin. Bloqueia
// inclusive o acesso direto por URL. Avisa o usuário por toast e o envia para
// a home (evita tela em branco no acesso direto por URL).
const ROLES_PERMITIDAS = ["super-admin", "admin"];

const somenteAdminCenso = async (to, from, next) => {
  let user = store.getters["Auth/user"];
  if (!user) {
    await $loaderService.loadBasicDataIfNeeded();
    user = store.getters["Auth/user"];
  }

  if (user && ROLES_PERMITIDAS.includes(user.roleName)) {
    return next();
  }

  $toast.danger("Você não tem permissão para acessar o módulo Censo Escolar.");
  return next({ name: "home" });
};

export default somenteAdminCenso;
